import React from 'react'
import styles from './CircularProgress.module.css'

class CircularProgress extends React.Component {
  render() {
    // Size of the enclosing square
    const sqSize = this.props.sqSize
    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (this.props.sqSize - this.props.strokeWidth) / 2
    // Enclose cicle in a circumscribing square
    const viewBox = `0 0 ${sqSize} ${sqSize}`
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * 2
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - dashArray * this.props.percentage / 100

    return (
      <div className={styles.base}>
        <div className={styles.icon}>
          <svg
            width={this.props.sqSize}
            height={this.props.sqSize}
            style={{ display: 'block' }}
            viewBox={viewBox}>
            <circle
              className={styles.background}
              cx={this.props.sqSize / 2}
              cy={this.props.sqSize / 2}
              r={radius}
              strokeWidth={`${this.props.strokeWidth - 1}px`} />
            <circle
              className={styles.progress}
              cx={this.props.sqSize / 2}
              cy={this.props.sqSize / 2}
              r={radius}
              strokeWidth={`${this.props.strokeWidth}px`}
              // Start progress marker at 12 O'Clock
              transform={`rotate(-90 ${this.props.sqSize / 2} ${this.props.sqSize / 2})`}
              style={{
                strokeDasharray: dashArray || 0,
                strokeDashoffset: dashOffset || 0
              }} />
          </svg>
        </div>
        <div className={styles.label}>
          <span>
            <span className={styles.labelScore}>{this.props.current}/</span>
            <span className={styles.labelTarget}>{this.props.total}</span>
          </span>
        </div>
      </div>
    )
  }
}

CircularProgress.defaultProps = {
  sqSize: 60,
  percentage: 25,
  strokeWidth: 6
}

export default CircularProgress
